import React, { useState, useEffect } from "react";
import packageJson from "../../../package.json";

function withClearCache(Component) {
  function ClearCacheComponent(props) {
    const [isLatestBuildDate, setIsLatestBuildDate] = useState(true);

    useEffect(() => {
      fetch("/meta.json?t=" + new Date().getTime(), {
        cache: "no-store",
        headers: {
          Pragma: "no-cache",
          "Cache-Control": "no-cache, no-store, must-revalidate",
        },
      })
        .then((response) => response.json())
        .then((meta) => {
          const latestVersionDate = meta.buildDate;
          const currentVersionDate = packageJson.buildDate;

          if (latestVersionDate > currentVersionDate) {
            clearCachesAndReload();
          } else {
            setIsLatestBuildDate(true);
          }
        })
        .catch(() => {
          setIsLatestBuildDate(true);
        });
    }, []);

    const clearCachesAndReload = async () => {
      if (caches) {
        const names = await caches.keys();
        await Promise.all(names.map((name) => caches.delete(name)));
      }
      window.location.reload();
    };

    return (
      <React.Fragment>
        {isLatestBuildDate ? <Component {...props} /> : null}
      </React.Fragment>
    );
  }

  return ClearCacheComponent;
}

export default withClearCache;
